import Ajax from './ajax';
import Contract from '../domain/contract';
import { cloneDeep } from 'lodash';

const initialState = {
    contractsById: {},
    loadingContracts: false,
    updatingContracts: false,
};

// Action types
export const GET_CONTRACT_DATA_REQ = 'contractrequest/GETCONTRACTDATAREQ';
export const GET_CONTRACT_DATA_SUCCESS = 'contractrequest/GETCONTRACTDATASUCCESS';
export const GET_CONTRACT_DATA_BY_ID_REQ = 'contractrequest/GETCONTRACTDATABYIDREQ';
export const GET_CONTRACT_DATA_BY_ID_SUCCESS = 'contractrequest/GETCONTRACTDATABYIDSUCCESS';
export const UPDATE_CONTRACT_DATA_REQ = 'contractrequest/UPDATECONTRACTDATAREQ';
export const UPDATE_CONTRACT_DATA_SUCCESS = 'contractrequest/UPDATECONTRACTDATASUCCESS';
export const UPDATE_CONTRACT_DATA_FAIL = 'contractrequest/UPDATECONTRACTDATAFAIL';
export const DELETE_CONTRACT_DATA_REQ = 'contractrequest/DELETECONTRACTDATAREQ';
export const DELETE_CONTRACT_DATA_SUCCESS = 'contractrequest/DELETECONTRACTDATASUCCESS';
export const DELETE_CONTRACT_DATA_FAIL = 'contractrequest/DELETECONTRACTDATAFAIL';
export const CREATE_CONTRACT_DATA_REQ = 'contractrequest/CREATECONTRACTDATAREQ';
export const CREATE_CONTRACT_DATA_SUCCESS = 'contractrequest/CREATECONTRACTDATASUCCESS';
export const CREATE_CONTRACT_DATA_FAIL = 'contractrequest/CREATECONTRACTDATAFAIL';

// Action creators
export const contractDataUpdated = (contract) => ({
    type: UPDATE_CONTRACT_DATA_SUCCESS,
    contract: contract,
});

export const contractDataDeleted = (contractId) => ({
    type: DELETE_CONTRACT_DATA_SUCCESS,
    contractId,
});

export const contractDataCreated = (contract) => ({
    type: CREATE_CONTRACT_DATA_SUCCESS,
    contract: contract,
});

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_CONTRACT_DATA_REQ:
            return {
                ...state,
                loadingContracts: true,
            };
        case GET_CONTRACT_DATA_SUCCESS:
            const contracts = action.contracts.map((c) => new Contract(c));
            const contractsById = contracts.reduce((acc, contract) => {
                acc[contract.contractNumber.id] = contract;
                return acc;
            }, {});
            return {
                ...state,
                contractsById: contractsById,
                loadingContracts: false,
            };
        case GET_CONTRACT_DATA_BY_ID_REQ:
            return {
                ...state,
                loadingContracts: true,
            };
        case GET_CONTRACT_DATA_BY_ID_SUCCESS: {
            const newContractData = cloneDeep(state.contractsById);
            newContractData[action.contractNumberId] = action.contract;
            return {
                ...state,
                contractsById: newContractData,
                loadingContracts: false,
            };
        }
        case UPDATE_CONTRACT_DATA_REQ:
            return {
                ...state,
                updatingContracts: true,
            };
        case UPDATE_CONTRACT_DATA_SUCCESS:
            return {
                ...state,
                updatingContracts: false,
                contractsById: {
                    ...state.contractsById,
                    [action.contract.contractNumber.id]: new Contract(action.contract),
                },
            };
        case UPDATE_CONTRACT_DATA_FAIL:
            return {
                ...state,
                updatingContracts: false,
            };
        case DELETE_CONTRACT_DATA_REQ: {
            return {
                ...state,
                updatingContracts: true,
            };
        }
        case DELETE_CONTRACT_DATA_SUCCESS: {
            const newContractData = cloneDeep(state.contractsById);
            delete newContractData[action.contractId];
            return {
                ...state,
                contractsById: newContractData,
                updatingContracts: false,
            };
        }
        case DELETE_CONTRACT_DATA_FAIL: {
            return {
                ...state,
                updatingContracts: false,
            };
        }
        case CREATE_CONTRACT_DATA_REQ: {
            return {
                ...state,
                updatingContracts: true,
            };
        }
        case CREATE_CONTRACT_DATA_SUCCESS: {
            return {
                ...state,
                updatingContracts: false,
                contractsById: {
                    ...state.contractsById,
                    [action.contract.contractNumber.id]: new Contract(action.contract),
                },
            };
        }
        case CREATE_CONTRACT_DATA_FAIL: {
            return {
                ...state,
                updatingContracts: false,
            };
        }
        default:
            return {
                ...state,
            };
    }
};

export const getContractData = () => {
    return async (dispatch) => {
        dispatch({
            type: GET_CONTRACT_DATA_REQ,
        });
        return Ajax.get('api/contract/')
            .then(function (data) {
                dispatch({
                    type: GET_CONTRACT_DATA_SUCCESS,
                    contracts: data.data,
                });
            })
            .catch(function (err) {
                console.log(err);
                return false;
            });
    };
};

export const updateContractData = (contract) => {
    return async (dispatch) => {
        dispatch({
            type: UPDATE_CONTRACT_DATA_REQ,
        });

        return await Ajax.put(`api/contract/${contract.contractNumber.id}`, contract)
            .then(function (data) {
                dispatch(contractDataUpdated(data.data));
            })
            .catch(function (err) {
                console.log(err);
                dispatch({
                    type: UPDATE_CONTRACT_DATA_FAIL,
                });
                return false;
            });
    };
};

export const deleteContract = (contractNumberId) => {
    return async (dispatch) => {
        dispatch({
            type: DELETE_CONTRACT_DATA_REQ,
        });

        await Ajax.delete(`api/contract/${contractNumberId}`)
            .then(function (data) {
                dispatch(contractDataDeleted(contractNumberId));
            })
            .catch(function (err) {
                console.log(err);
                dispatch({
                    type: DELETE_CONTRACT_DATA_FAIL,
                });
                return false;
            });
    };
};

export const getUsage = async (contractNumberId) => {
    const resp = await Ajax.get(`api/contract/${contractNumberId}/usage`);
    return resp.data;
};

export const createContract = (contractNumber, tenantCompanyClusterId) => {
    return async (dispatch) => {
        dispatch({
            type: CREATE_CONTRACT_DATA_REQ,
        });

        // Contract admin is a cross-tenant view (not scoped to "current" tenant) -- the tenant must be
        // explicitly selected in the UI and sent here, it is never inferred on the backend.
        return await Ajax.post('api/contract/', { contractNumber, tenantCompanyClusterId })
            .then(function (data) {
                dispatch(contractDataCreated(data.data));
                return data.data;
            })
            .catch(function (err) {
                console.log(err);
                dispatch({
                    type: CREATE_CONTRACT_DATA_FAIL,
                });
                throw err;
            });
    };
};
